module.exports = __webpack_public_path__ + "assets/img/Slice 164(4).16528598.png";